import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IOption } from '../../../../ui/interfaces/option';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { CashKey } from '../../cash/cash-key';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { FormService } from '../../../../shared/services/form.service';
import { CodeService } from '../../../../services/ServiceEntity/code.service';
import { CUserService } from '../../../../services/ServiceEntity/c-user.service';
import { TransactionsService } from '../../../../services/ServiceEntity/transactions.service';
import { AccountUserService } from '../../../../services/ServiceEntity/account-user.service';
import { CountryColumnName } from '../../countries/country-column-name';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { TCModalService } from '../../../../ui/services/modal/modal.service';
import { CostsRuleService } from '../../fees/costs-rule.service';
import { CountryService } from '../../countries/countries.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { filter, map, takeUntil } from 'rxjs/operators';
import { BASE_URL } from '../../../../../environments/environment';
import { LABEL_FORM_CLASS, SUFFIX_ICON_FORM } from '../../../../shared/constant/css-style/css-class.constant';
import { IMobileAccount } from '../../../../model/mobile-account.model';
import { STATUS } from '../../../../model/account.model';
import { STATUS_OK, TIME_LONG_REQUEST, TIME_MIN_X_REQUEST } from '../../../../shared/constant/request.contant';
import { Content } from '../../../../ui/interfaces/modal';
import { DynamicFormModel } from '../../../../model/champs_formulaire/dynamic-form.model';
import { ChampsFormulaireService } from '../../champs_formulaires/champs_formulaires/champs-formulaire.service';
import { BaseDynamicComponent } from '../../../../shared/layouts/base-dynamic.component';
import { DynamicService } from '../../../../services/dynamic.service';
import { DynamicFormInit, IBuildingFormByStep, IDynamicFormInit, INextForm } from '../dynamic-form.init';
import { RetraitCodeValidDynamicComponent } from '../retrait-code-valid-dynamic/retrait-code-valid-dynamic.component';
import { ErrorServConstant } from '../../../../shared/constant/error.constant';
import { ICashModel } from '../../cash/cash-data-model';

/**
 * Permet à une personne de retirer de l'argent
 * à partir d'un code. La personne peut soit retirer
 * tout le montant ou soit une partie.
 */
@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  animations: [fadeIn]
})
export class VerificationCodeComponent extends BaseDynamicComponent
  implements OnInit, OnDestroy {

  // transfertCode: FormGroup;
  retraitCode: UntypedFormGroup;
  allCachOutForm: UntypedFormGroup;
  PartialCachOutForm: UntypedFormGroup;
  TransfertCompteForm: UntypedFormGroup;

  isCountryNotTheSame = false;

  loadingMessagesForm: boolean;
  loadingCodeForm: boolean;
  loadingAllCashOut: boolean;
  loadingPartialCashOut: boolean;
  loadingTransfertCompte: boolean;

  CurentUser: any;
  CurrentUserAuth: any;
  CurentUserCuser: any;
  currentMobileAccount: any;
  cUserMobileAccount: any;
  accountNumber: any;
  countrylist: IOption[];
  country: any;
  countries: any;
  SelectedContry: any;
  //
  sentAmount: number;
  countryTrader: string;
  moneySource: string;
  countryReceiver: string;
  moneyDest: string;
  error: string;

  // dynamicFormModels: DynamicFormModel[] = [];
  // lastIndexForm = 0;
  // previousIndexForm = 0;
  // tabOption: any[] = [];
  // init = false;
//  hasBuiltList = false;
  dynamicFormModelsDefault: DynamicFormModel[];
  nextFormData: INextForm;
  buildingFormData: IBuildingFormByStep;

  fields: IDynamicFormInit;
  //
  ReponseTransfert: any;
  successTransfert = false;
  errorTransfert = false;
  CountryDestID: any;
  //Tabs
  TabsEnvoiCode: boolean;
  TabsTransFert: boolean;
  retraitCodeForm: boolean;
  theDialogRef: MatDialogRef<any>;

  //retrait Code
  //All cash, partial cash and Transfert Compte
  AllcashOutPane = false;
  PartialCashPane = false;

  //transfertCompte
  transfertCompteSuccess = false;
  transfertCompteFail = false;
  transfertCompteERROR: any;

  private subs$ = new Subject<void>();

  //Identity type
  identityType: IOption[] = [
    {
      'label': 'CNI',
      'value': 'CNI'
    },
    {
      'label': 'Passe Port',
      'value': 'Passe Port'
    },
    {
      'label': 'Permis conduire',
      'value': 'Permis conduire'
    },
    {
      'label': 'Carte Résident',
      'value': 'Carte Résident'
    }
  ];

  finalAllCashOutVal: any;
  finalPartialCashOutVal: any;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ICashModel,
    private errorServConstant: ErrorServConstant,
    private dynamicFormInit: DynamicFormInit,
    private dialog: MatDialog,
    protected dynamicService: DynamicService,
    private cashKey: CashKey,
    private formulaireService: ChampsFormulaireService,
    private accountService: AccountService,
    private formService: FormService,
    private codeService: CodeService,
    private cUserService: CUserService,
    private transactionsService: TransactionsService,
    private mAccountService: AccountUserService,
    private dialogRef: MatDialogRef<VerificationCodeComponent>,
    private columnName: CountryColumnName,
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    private modal: TCModalService,
    private costsRuleService: CostsRuleService,
    private countryService: CountryService,
    store: Store<IAppState>, httpSv: HttpService) {
    super(dynamicService, store, httpSv);
    console.log('## construct envoi code');

    this.loadingMessagesForm = false;
    this.theDialogRef = this.dialogRef;
    this.fields = this.dynamicFormInit.getFields();

    // this.cashService.setElement(this.cashKey.appTabsRetraitCode, true);
    // this.cashService.setElement(this.cashKey.appRetraitCodeValide, false);
    this.retraitCodeForm = true;

    this.countrylist = [];
    let verificationCode = this.fb.group({});

    this.buildingFormData = {
      lastIndexForm: 0,
      previousIndexForm: 0,
      dynamicFormModels: [],
      bodyModels: [],
      headerModels: []
    };

    this.nextFormData = {
      init: false,
      formulaire: verificationCode,
      formBuilder: this.fb,
      dynamicFormModelsDefault: null,
      hasBuiltList: false,
      tabOption: [],
      buildingFormByStep: this.buildingFormData
    };
    //  this.initTransfertCode();
  }

  ngOnInit(): void {
    console.log('## init envoi code');
    this.initMsgResult();
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(account => {
        console.log('## get account');
        this.CurentUser = account;
        console.log('POINT CASH', this.CurentUser);

        console.log('## the datacode: ', this.data.cashDataModel.dataCode);

        this.initRetraitCode();
        //  this.initAllCashOutForm();
        //  this.initPartialCashOutForm();
        this.getCurrentCuser();
        this.getData('assets/data/table.json', 'tableData',
          'setLoaded');
        this.getData(`${BASE_URL}countries`, 'countries',
          'initCountry');
        let params = new HttpParams();
        params = params.set('idServiceItem', String(this.data.cashDataModel.dataCode.idServiceItemVerif));
        this.formulaireService.query(this.formulaireService.dynamicFormApi, params)
          .pipe(map(res => res.body))
          .subscribe((res: DynamicFormModel[]) => {
            console.log('## success get list forms');
            console.log('## res: ', res);
            this.nextForm(res, this.nextFormData);
          }, error => {
            console.log('## error get list forms: ', error);
          });
      });
  }

  ngOnDestroy() {
    console.log('## destroy envoi code');
    // this.cashService.clear();
    this.formService.free(this.subs$);
  }

  getHeaders() {
    return this.buildingFormData.headerModels;
  }

  getInit() {
    return this.nextFormData.init;
  }

  anyLastIndexForm(d: DynamicFormModel[]) {
    return (this.buildingFormData.lastIndexForm < d.length);
  }

  anyPreviousIndexForm(d: DynamicFormModel[]) {
    return (this.buildingFormData.previousIndexForm > 0);
  }

  /**
   * Permet de charger les éléments du formulaire
   * de l'étape suivante.
   * @param res tous les champs du formulaire.
   */
  buildPreviousForm(res: DynamicFormModel[]) {
    this.nextFormData.init = false;
    let formList = [];
    if (res.length > 0 && this.buildingFormData.previousIndexForm >= 0) {
      let i = this.buildingFormData.previousIndexForm;
      this.buildingFormData.lastIndexForm = i + 1;
      let next = res[i].formulaire.steps;
      let prev;
      for (; i >= 0; i--) {
        prev = res[i].formulaire.steps;
        if (prev != next) {
          break;
        } else {
          next = prev;
        }
        formList.push(res[i]);
      }
      if (this.buildingFormData.previousIndexForm === -1) {
        this.buildingFormData.previousIndexForm = 0;
      } else {
        this.buildingFormData.previousIndexForm = i;
      }
      this.buildingFormData.dynamicFormModels = formList;
    }
    setTimeout(r => {
      this.nextFormData.init = true;
    }, TIME_MIN_X_REQUEST);
    this.buildFromEnum(null);
  }

  /**
   * Permet de charger les éléments du formulaire
   * de l'étape suivante.
   * Construit aussi les validateurs.
   * @param res tous les champs du formulaire.
   */
  /*nextForm(res: DynamicFormModel[]) {
    this.init = false;
    this.dynamicFormModelsDefault = res;
    this.buildFormByStep(res);
    this.buildList(this.dynamicFormModels, this.tabOption);
    if(!this.hasBuiltList) {
      this.transfertCode = this.initTransfertCodeDynamic(this.dynamicFormModelsDefault,
        this.fb);
      this.hasBuiltList = true;
    }
    setTimeout( r => {
      this.init = true;
    }, TIME_MIN_X_REQUEST)
    this.buildFromEnum(null);
  }*/

  /**
   * Permet de charger les éléments du formulaire
   * de l'étape suivante.
   * @param res tous les champs du formulaire.
   */

  /*buildFormByStep(res: DynamicFormModel[]) {
    let formList = [];
    if (res.length > 0 && this.lastIndexForm < res.length) {
      let i = this.lastIndexForm;
      this.previousIndexForm = i-1;
      let prev = res[i].formulaire.steps;
      let next;
      for (; i < res.length; i++) {
        next = res[i].formulaire.steps;
        if (prev != next) {
          break;
        } else {
          prev = next;
        }
        formList.push(res[i]);
      }
      if(res.length === this.lastIndexForm) {
        this.lastIndexForm = i-1;
      } else {
        this.lastIndexForm = i;
      }
      this.dynamicFormModels = formList;
    }
  }*/

  initMsgResult() {
    this.errorTransfert = false;
    this.successTransfert = false;
  }

  getLabelFormClass() {
    return LABEL_FORM_CLASS;
  }

  getSuffixIconForm(): string {
    return SUFFIX_ICON_FORM;
  }

  /* getTabRetraitCode(): boolean {
     return this.cashService
       .getElement(this.cashKey.appTabsRetraitCode).value;
   }

   getRetraitCodeValide(): boolean {
     return this.cashService
       .getElement(this.cashKey.appRetraitCodeValide).value;
   }*/

  /*initTransfertCode() {
    console.log('## init transfert code form');
    this.transfertCode = this.fb.group({
      numberAccount: [''],
      senderfName: ['', [Validators.required]],
      senderlName: ['', [Validators.required]],
      senderNumTel: ['', [Validators.required]],
      password: ['', [Validators.required]],
      sentAmount: ['', [Validators.required]],
      labelCountry: ['', Validators.required],
      receiverfName: ['', Validators.required],
      receiverlName: ['', Validators.required],
      receiverNumTel: ['', [Validators.required]],
      ReceivedAmount: [],
      serviceItemId: [102],
      preferenceCurrency: ['XOF']
    });
  }*/

  AllcashOut() {
    this.AllcashOutPane = true;
    this.PartialCashPane = false;
  }

  PartialcashOut() {
    this.AllcashOutPane = false;
    this.PartialCashPane = true;
  }

  initRetraitCode() {
    this.retraitCode = this.fb.group({
      envoiCode: ['', [Validators.required]]
    });
  }

  initAllCashOutForm() {
    this.allCachOutForm = this.fb.group({
      identityType: ['', [Validators.required]],
      identityNumber: ['', [Validators.required]],
      password: ['', [Validators.required]],
      valueCode: [''],
      serviceItemId: [''],
      receivedAmount: [''],
      numberAccount: [''],
      receiverNumTel: [''],
      senderId: [''],
      receiverId: ['']
    });
  }

  sendRetraitCode(valid: boolean) {
    if (valid) {
      this.loadingCodeForm = true;

      setTimeout(() => {
        this.loadingCodeForm = false;
        this.retraitCode.reset();
      }, 1000);
    }
  }

  //For All cash out
  sendAllCashOut(valid: boolean) {
    if (valid) {
      this.loadingAllCashOut = true;

      setTimeout(() => {
        this.loadingAllCashOut = false;
        this.allCachOutForm.reset();
      }, 1000);
    }
  }

  //Partial Cash Out
  sendPartialCashOut(valid: boolean) {
    if (valid) {
      this.loadingPartialCashOut = true;

      setTimeout(() => {
        this.loadingPartialCashOut = false;
        this.PartialCachOutForm.reset();
      }, 1000);
    }
  }

  //Valide All Cash Out
  DoneAllCachOutForm(modalRetaitCodeBody: any) {
    //init Val
    // const code = this.cashService.getCode();
    const code = undefined;
    this.allCachOutForm.value.valueCode = code.valueCode;
    this.allCachOutForm.value.serviceItemId = 102;
    this.allCachOutForm.value.receivedAmount = code.amount;
    this.allCachOutForm.value.numberAccount = this.accountNumber;
    this.allCachOutForm.value.senderId = code.senderId;
    this.allCachOutForm.value.receiverId = code.receiverId;

    this.transactionsService.withdrawalCode(this.allCachOutForm.value).subscribe((rep) => {
      console.log('### SUCCESS Retrait ALL CASH OUT', rep);
      //setTimeout(()=>{},1000);
      this.finalAllCashOutVal = rep;
      this.openModal(modalRetaitCodeBody, 'Resultats du retrait CODE All CASH', null, { closeButton: true, overlayClose: false });
      this.allCachOutForm.reset();
    }, err => {
      console.log('### ERROR Retrait ALL CASH OUT', err);
    });
  }

  getColorbyReponse() {
    /*if (this.cashService.getCode().status === 'ACTIVED') {
      return 'black';
    } else {
      return 'red';
    }*/
    return 'red';
  }

  retraitCodeSuccess() {
    // this.cashService.setElement(this.cashKey.appTabsRetraitCode, false);
    //  this.cashService.setElement(this.cashKey.appRetraitCodeValide, true);
    //  this.cashService.setElement(this.cashKey.retraitCodeValide, true);
    this.successTransfert = false;
  }

  DisableRetraitCodeSuccess() {
    //   this.TabsRetraitCode = true;

    //   this.RetraitCodeValide = false;
    this.AllcashOutPane = false;
    this.PartialCashPane = false;
  }

  getCode() {
    // return this.cashService.getCode();
    return 'a';
  }

  retraitCash() {
    //GetMapping("api/codes/valueCode/{code}")
    console.log('### RETRAIT', this.retraitCode.value.envoiCode);
    this.loadingMessagesForm = true;
    this.initMsgResult();
    this.codeService.verifCode(this.retraitCode.value.envoiCode).subscribe((result) => {
      console.log('### RETRAIT CASH RESULT', result.body);
      // this.cashService.setCode(result.body);
      this.retraitCode.reset();
      this.successTransfert = true;
      this.retraitCodeSuccess();
      this.errorTransfert = false;
      this.loadingMessagesForm = false;
      //this.openModal(modalRetaitCodeBody,"Retrait Code Result");
    }, err => {
      console.log(err);
      console.log('## error: ', err);
      this.successTransfert = false;
      this.loadingMessagesForm = false;
      this.errorTransfert = true;
    });
  }

  //Valider Partial Cash OUT
  DonePartialCashOut(modalRetaitCodeBody: any) {
    //init Val
    // const code = this.cashService.getCode();
    const code = undefined;
    this.PartialCachOutForm.value.valueCode = code.valueCode;
    this.PartialCachOutForm.value.serviceItemId = 102;
    this.PartialCachOutForm.value.receiverNumTel = code.receiverNumTel;
    //this.PartialCachOutForm.value.receivedAmount= code.amount;
    this.PartialCachOutForm.value.numberAccount = this.accountNumber;
    this.PartialCachOutForm.value.senderId = code.senderId;
    this.PartialCachOutForm.value.receiverId = code.receiverId;

    this.transactionsService.withdrawalCode(this.PartialCachOutForm.value).subscribe((rep) => {
      console.log('### SUCCESS Retrait PARTIAL CASH OUT', rep);
      //setTimeout(()=>{},1000);
      this.finalAllCashOutVal = rep;
      this.openModal(modalRetaitCodeBody, 'Resultats du retrait CODE PARTIAL CASH', null, { closeButton: true, overlayClose: false });
      this.PartialCachOutForm.reset();
    }, err => {
      console.log('### ERROR Retrait PARTIAL CASH OUT', err);
    });

  }

  resetRetraitCodeForm() {
    this.retraitCode.reset();
    this.loadingCodeForm = false;
  }

  //All Cash Out Reset
  ResetAllCashOut() {
    this.allCachOutForm.reset();
    this.loadingAllCashOut = false;
  }

  //partial Cash out
  ResetPartialCashOut() {
    this.PartialCachOutForm.reset();
    this.loadingPartialCashOut = false;


  }

  //for partial Cash Out
  initPartialCashOutForm() {
    this.PartialCachOutForm = this.fb.group({
      identityType: ['', [Validators.required]],
      identityNumber: ['', [Validators.required]],
      password: ['', [Validators.required]],
      valueCode: [''],
      serviceItemId: [''],
      receivedAmount: ['', [Validators.required]],
      numberAccount: [''],
      receiverNumTel: [''],
      senderId: [''],
      receiverId: ['']
    });
  }


  getCurrentCuser() {
    this.cUserService.findOneByUserLogin(this.CurentUser.login).subscribe((response) => {
      this.CurentUserCuser = response.body;
      console.log('CUSER POINT CASH', this.CurentUserCuser);
      //console.log("Current User",this.CurentUser);
      this.getCurrentMobileAccount();
    }, (err) => {
      console.log(err);
    });
  }

  getCurrentMobileAccount() {
    this.mAccountService.findAllAccountsByCUserId(this.CurentUserCuser.id)
      .pipe(
        filter((res: HttpResponse<IMobileAccount[]>) => res.ok),
        map((res: HttpResponse<IMobileAccount[]>) => res.body)
      )
      .subscribe((val: IMobileAccount[]) => {
        console.log('## mobiles accounts: ', val);
        const res = val.filter(m => (m.status === STATUS.actived));
        console.log('## res:', res);
        this.cUserMobileAccount = res['0'];
        //  this.cUserMobileAccount = val['0'];
        this.accountNumber = this.cUserMobileAccount.numberAccount;
        console.log('NUMBER Account', this.accountNumber);
      }, err => {
        console.log(err);
      });
  }

  getCountryByLabel(label) {
    this.getData(`${BASE_URL}countries/label/${label}`, 'country', 'initCountryDestID');
  }

  initCountryDestID() {
    setTimeout(() => {
      this.CountryDestID = this.country.mId;
      console.log('### DESt Country ID', this.CountryDestID);
    }, 0);
  }

  copyInputMessage(inputElement) {
    console.log('## copy: ', inputElement);
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    console.log('## copy: ', inputElement.value);
  }

  getFormData(f: UntypedFormGroup): FormData {
    const data = new FormData();
    Object.keys(f.controls).forEach(key => {
      data.append(key, f.value[key]);
    });
    return data;
  }

  verifCode(forModal: any, forfooter?: any) {
    //GetMapping("api/codes/valueCode/{code}")
    console.log('### RETRAIT', this.retraitCode.value.envoiCode);
    this.isCountryNotTheSame = false;
    this.loadingMessagesForm = true;
    this.initMsgResult();

    console.log('## cuser current: ', this.accountNumber);

    const data = this.getFormData(this.nextFormData.formulaire);
    data.set('serviceItemId', '' + this.data.cashDataModel.dataCode.serviceItemIdVerif);
    data.set('numberAccount', '' + this.accountNumber);
    this.showKeys(data);

    console.log('## fields code: ', data.get(this.fields.valueCode));
    this.data.cashDataModel.dataCode.code = data.get(this.fields.valueCode);

    this.codeService.verifCodeDynamic(data)
      .subscribe((result) => {
        console.log('### result', result);
        console.log('### RETRAIT CASH RESULT', result.body);
        let status = result.status;
        if (status === STATUS_OK) {
          this.isCountryNotTheSame = false;
          this.data.cashDataModel.setCode(result.body);
          this.retraitCode.reset();
          this.successTransfert = true;
          this.retraitCodeSuccess();
          this.errorTransfert = false;
          this.loadingMessagesForm = false;
          console.log('## coding: ', this.data.cashDataModel.dataCode.code);
          this.data.cashDataModel.openRetraitCodeValidDynamic(this.dialog,
            RetraitCodeValidDynamicComponent, this.data);
          this.dialogRef.close();
        } else {
          this.resetWhenError();
        }
        //this.openModal(modalRetaitCodeBody,"Retrait Code Result")
      }, err => {
        console.log(err);
        this.resetWhenError();
        this.manageErrorFromServer(err);
      });
  }

  /**
   * Gère les erreurs lors de la vérification d'un code.
   * @param err les erreurs.
   */
  manageErrorFromServer(err: HttpErrorResponse) {
    const erreur = (err.error && err.error.myException) ? err.error.myException[0] : undefined;
    if (erreur && (erreur.errorCode === this.errorServConstant.COUNTRY_RECEIVER_NOT_EQUAL_SENDER)) {
      const fields = erreur.fields;
      this.isCountryNotTheSame = !!fields.valueCode;
    }
  }

  resetWhenError() {
    this.successTransfert = false;
    this.loadingMessagesForm = false;
    this.errorTransfert = true;
  }

  /**
   * Permet d'effectuer un envoie code.
   * @param forModal
   * @param forfooter
   * @constructor
   */

  /*envoiCode(forModal: any, forfooter?: any) {
    console.log('## envoie code');
    this.loadingMessagesForm = true;
    this.successTransfert = false;
    this.errorTransfert = false;
    this.getCountryByLabel(this.transfertCode.value.labelCountry);
    this.transfertCode.value.numberAccount = this.accountNumber;
    console.log('## number account: ', this.transfertCode.value.numberAccount);
    console.log('### POST:', this.transfertCode.value);
    setTimeout(
      () => {
        if (this.CurentUserCuser.countryId === this.CountryDestID) {//transfert National
          console.log('transfert NATIONAL');
          this.transactionsService.transferCode(this.transfertCode.value)
            .subscribe((rep) => {
              console.log('### SUCCESS Transfert Code', rep);
              this.manageMessageWhenSucceed(rep);
              this.showDetailsEnvoieCode(forModal,
                'Details Transaction', null,
                {
                  closeButton: true,
                  overlayClose: false
                }); // after 700ms
            }, err => {
              console.log('ERROR While TRANS', err);
              this.manageMessageWhenError();
            });
        } else {//transfert International api/transactions/transferCodeInter
          console.log('transfert INTERNATIONAL');
          console.log('CUSER CURRENT', this.CurentUserCuser.countryId);
          this.transactionsService.transferCodeInter(this.transfertCode.value)
            .subscribe((rep) => {
              console.log('### SUCCESS Transfert Code', rep);
              this.manageMessageWhenSucceed(rep);
              this.showDetailsEnvoieCode(forModal,
                'Details Transaction', null,
                {
                  closeButton: true,
                  overlayClose: false
                }); // after 700ms
            }, err => {
              console.log('ERROR While TRANS', err);
              this.manageMessageWhenError();
            });
        }
      },
      1000
    );
  }*/

  /**
   * Affiche les détails de la transaction
   * lorsqu'elle a réussi.
   * @param modal
   * @param title
   * @param footer
   * @param options
   */
  showDetailsEnvoieCode(modal, title: string, footer, options) {
    console.log('## showDetailsEnvoieCode');
    console.log('## modal: ', modal);
    console.log('## title: ', title);
    setTimeout(() => {
      this.openModal(modal, title, footer, options, 'envoi-code');
    }, TIME_LONG_REQUEST);
  }

  /**
   * show or delete message infos.
   * @param response the response of the transaction.
   * @private
   */
  private manageMessageWhenError() {
    this.successTransfert = false;
    this.loadingMessagesForm = false;
    this.errorTransfert = true;
  }

  /**
   * show or delete message infos.
   * @param response the response of the transaction.
   * @private
   */
  private manageMessageWhenSucceed(response) {
    this.errorTransfert = false;
    this.loadingMessagesForm = false;
    this.successTransfert = true;
    this.ReponseTransfert = response;
    this.nextFormData.formulaire.reset();
  }

  //Initialiser les Country pour le Select
  initCountry() {
    console.log('## init country');
    setTimeout(() => {
      console.log('COUNTRIES size: ', this.countries?.length);
      this.countrylist = [];
      this.countries?.forEach(element => {
        console.log('## country element: ', element);
        this.countrylist.push({ 'label': element.label, 'value': element.label });
      });
    });
  }

  resetMessagesForm() {
    this.nextFormData.formulaire.reset();
    this.loadingMessagesForm = false;
  }

  openModal<T>(body: Content<T>, header: Content<T> = null,
               footer: Content<T> = null, options: any = null,
               theClass?: string) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options,
      theClass: theClass
    });
  }

  closeModal() {
    console.log('## close envoi code');
    this.dialogRef.close();
  }

  isInvalid(): boolean {
    return this.formService.isInvalidForm(this.nextFormData.formulaire);
  }

  isRequired(column: string): boolean {
    return this.formService.isRequired(this.nextFormData.formulaire, column);
  }

  isInvalidDirtyOrtouched(column: string): boolean {
    return this.formService.isInvalidDirtyOrTouched(this.nextFormData.formulaire,
      column);
  }

  getMinLength(column: string): number {
    return this.formService.getMinLength(this.nextFormData.formulaire, column);
  }

  getMaxLength(column: string): number {
    return this.formService.getMaxLength(this.nextFormData.formulaire, column);
  }

  hasErrorEmail(column: string): boolean {
    return this.formService.hasErrorEmail(this.nextFormData.formulaire, column);
  }

  hasErrorPattern(column: string): boolean {
    return this.formService.hasErrorPattern(this.nextFormData.formulaire, column);
  }

  hasErrorMinLength(column: string): boolean {
    return this.formService.hasErrorMinLength(this.nextFormData.formulaire, column);
  }

  hasErrorMaxLength(column: string): boolean {
    return this.formService.hasErrorMaxLength(this.nextFormData.formulaire, column);
  }

}
